module.exports = __webpack_public_path__ + "static/media/dfgoogleplay.3d250a94.svg";